export default {
  methods: {
    $t_v2(key, defaultValue) {
      if (this.$t) {
        const value = this.$t(key);

        if (value && value !== key) {
          return value;
        }
      }

      return defaultValue || key;
    },
  },
};
